import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsWaterNormalMedium = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M26.67 17.18a5.02 5.02 0 01-4.5-2.7l-.25-.47h-1.17l-.25.47a5.1 5.1 0 01-9 0l-.25-.47h-1.17l-.25.47a5.021 5.021 0 01-4.5 2.7A5.036 5.036 0 011 14.77v2.49a6.6 6.6 0 004.33 1.57 6.65 6.65 0 005.34-2.61 6.747 6.747 0 0010.66 0A6.763 6.763 0 0031 17.26v-2.49a5.036 5.036 0 01-4.33 2.41zm-10.17 10a5.2 5.2 0 01-4.66-2.8l-.2-.38h-1.28l-.2.38a5.2 5.2 0 01-4.66 2.8A5.193 5.193 0 011 24.66v2.51a6.754 6.754 0 004.5 1.66 6.82 6.82 0 005.5-2.71 6.933 6.933 0 0010 1.05v-2.51a5.193 5.193 0 01-4.5 2.52zm10-20a5.2 5.2 0 01-4.66-2.8l-.32-.6h-1.04l-.32.6a5.278 5.278 0 01-9.32 0l-.11-.21-.01.01v2.74A6.936 6.936 0 0021 6.12a6.821 6.821 0 005.5 2.71A6.754 6.754 0 0031 7.17V4.66a5.193 5.193 0 01-4.5 2.52z"
        fill=""
      />
    </svg>
  )
);
SvgSportsWaterNormalMedium.defaultProps = {
  color: 'currentColor',
  size: 32,
  title: undefined,
  titleId: undefined
};
SvgSportsWaterNormalMedium.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsWaterNormalMedium;
